module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'form',
        'propertiesForm',
    ],

    config: {
        entityContext: 'prices',
        preventClearOnCancel: true,
    },

    methods: {

        dataDealer(){
            this.model.namedFields.valid.config = this.model.namedFields.valid.config || {}
            this.model.namedFields.valid.config.disabled = true
        },

        onTypeChange: function(type){
            let fieldCodeVisibility = {}
            if(type === 'hourlyRate'){
                fieldCodeVisibility = {
                    hourlyRate: true,
                    flatScale: false
                }
            } else if (type === 'flatScale') {
                fieldCodeVisibility = {
                    hourlyRate: false,
                    flatScale: true
                }
            }

            const selectors = {
                show: [],
                hide: []
            }
            for(const fieldCode in fieldCodeVisibility) {
                if (fieldCodeVisibility[fieldCode]) {
                    selectors.show.push(`[data-field-code="${fieldCode}"]`)
                } else {
                    selectors.hide.push(`[data-field-code="${fieldCode}"]`)
                }
            }

            if(selectors.show.length > 0){
                this.$.find(selectors.show.join(', '))
                    .removeAttr('disabled', 'disabled')
                    .closest('.field')
                    .show()
                ;
            }
            if(selectors.hide.length > 0){
                this.$.find(selectors.hide.join(', '))
                    .attr('disabled', 'disabled')
                    .closest('.field')
                    .hide()
                ;
            }
        },

        /**
         * this function will be called after the form values has been changed.
         *
         * @param isRelationChange 		boolean - was the change related to a relation or not
         * @param changeDone 			boolean - has a change been done
         * @param fieldData 			{} - fieldData used to define what to do
         */
        onChange: function(isRelationChange, changeDone, fieldData){
            fieldData = fieldData || {}
            if(!this.config.creationMode && (this.config.updateTabTitleForFieldCodes || {})[fieldData.fieldCode || '']){
                this.updateTabTitle()
            }

            this.onTypeChange(this.getFieldValue('type'))
        },
    },

    hooks: {
        _attach(){
            this.onTypeChange(this.getFieldValue('type'))
        }
    }
}